/**
* @ComponentFor EditorialBlock
*/
import React from 'react';
import connect from 'Shared/connect';
import { epiPropertyValue, EpiProperty } from '@polarnopyret/scope-episerver';
import EditorialBlock from './EditorialBlock.type';
import { styled, StyledProps } from '@glitz/react';
import { isCompact } from 'Shared/Viewport';
import HorizontalAlign from 'Shared/Enums/HorizontalAlign.type';
import { GridWrap } from 'Shared/PageLayout';
import { createGridClasses, createOffsetGridClassLarge } from 'Shared/grid';

type ConnectedPropType = {
  currentBreakpoint: number;
};
 
type PropType = EditorialBlock & ConnectedPropType & StyledProps;
 
const imageLeft = (align: HorizontalAlign) => {
  switch (align) {
    case 'left':
      return true;
    default:
      return false;
  }
};

const DefaultImage = styled.img({
  width: 'auto',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
  borderRadius: 8
})

function EditorialBlock(props: PropType) {
  const isMobile = isCompact(props.currentBreakpoint);
  const imageToTheLeft = imageLeft(epiPropertyValue(props.horizontalAlign));
  const image = epiPropertyValue(props.image);
  const standardMargins = !epiPropertyValue(props.noStandardMargins);

  if(image) {
    const imageBox = (<DefaultImage
      src={image.url}
      alt={''}
    />);

    const contentBox = (
      <EpiProperty className={'editorial-text'}
        propertyComponentProps={{ isMobile }}
        for={props.mainBody}
      />
    );
    
    const rightElement = imageToTheLeft ? contentBox : imageBox;
    const leftElement = imageToTheLeft ? imageBox : contentBox;

    return (
      <GridWrap
        className='grid wsb'
        css={{
          ...(standardMargins && {
            padding: !isMobile
              ? {
                  y: '80px',
                }
              : {
                  y: '40px',
                },
          }),
          flexDirection: isMobile ? imageToTheLeft ? 'column' : 'column-reverse' : imageToTheLeft ? 'row' : 'row-reverse',
        }}
      >
        <div className={createGridClasses(12, 5, standardMargins ? createOffsetGridClassLarge(2) : '')}>
          {leftElement}
        </div>
        <div className={createGridClasses(12, 5)}>
          {rightElement}
        </div>
      </GridWrap>
    );  
  }
  
  return (
    <GridWrap
      className='wsb'
      css={{
        ...(standardMargins && {
          padding: !isMobile
            ? {
                y: '72px',
              }
            : {
                y: '32px',
              },
        }),  
      }}
    >
      <EpiProperty
        className={standardMargins ? 'editorial-text wide' : 'editorial-text'}
        propertyComponentProps={{ isMobile }}
        for={props.mainBody}
      />
    </GridWrap>
  );
}
 
export default connect(state => ({
  currentBreakpoint: state.currentBreakpoint,
}))(styled(EditorialBlock));
 